import { useEffect, useRef } from 'react'

/**
 * Re-executa o callback quando a aba/documento volta ao foco (visibilitychange).
 * Ignora a primeira chamada (mount) para não duplicar o fetch inicial.
 */
export function useRefetchOnFocus(callback: () => void) {
  const hasBeenHidden = useRef(false)

  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === 'hidden') {
        hasBeenHidden.current = true
        return
      }
      if (document.visibilityState === 'visible' && hasBeenHidden.current) {
        hasBeenHidden.current = false
        // Pequeno delay para dar tempo do token ser refreshado no AuthContext
        setTimeout(callback, 500)
      }
    }

    document.addEventListener('visibilitychange', handleVisibility)
    return () => document.removeEventListener('visibilitychange', handleVisibility)
  }, [callback])
}
